"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortDirections = void 0;
var SortDirections;
(function (SortDirections) {
    SortDirections["Ascending"] = "asc";
    SortDirections["Descending"] = "desc";
})(SortDirections = exports.SortDirections || (exports.SortDirections = {}));
//# sourceMappingURL=sort-directions.js.map